export const geolocationErrors = {
  1: "Usuário negou a solicitação de Geolocalização.",
  2: "A localização não está disponível.",
  3: "A solicitação para obter a localização expirou.",
  0: "Ocorreu um erro desconhecido.",
};